import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FactSection } from './FactSection';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const f = (fact)=>fact;
export function GatesView({ pipeline, projectId }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-5",
        children: [
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Security Clearances",
                facts: pipeline.securityClearances ?? [],
                accent: "red",
                projectId: projectId,
                titleFn: (v)=>f(v).level || 'Security clearance',
                metaFn: (v)=>f(v).description || f(v).scope?.replace(/_/g, ' ')
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Award Mechanism",
                facts: pipeline.awardMechanisms ?? [],
                accent: "blue",
                projectId: projectId,
                titleFn: (v)=>f(v).type?.replace(/_/g, ' ') || 'Award mechanism',
                metaFn: (v)=>f(v).awardCount ? `${f(v).awardCount} award(s)` : undefined
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Contract Type",
                facts: pipeline.contractTypes ?? [],
                accent: "blue",
                projectId: projectId,
                titleFn: (v)=>f(v).type || 'Contract type'
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Bonds",
                facts: pipeline.bonds ?? [],
                accent: "amber",
                projectId: projectId,
                titleFn: (v)=>f(v).bondType?.replace(/_/g, ' ') || 'Bond'
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Teaming Restrictions",
                facts: pipeline.teamingRestrictions ?? [],
                accent: "slate",
                projectId: projectId,
                titleFn: ()=>'Teaming restriction'
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Place of Performance",
                facts: pipeline.placesOfPerformance ?? [],
                accent: "slate",
                projectId: projectId,
                titleFn: (v)=>f(v).locations?.join(' · ') || 'Place of performance',
                metaFn: (v)=>{
                    const parts = [];
                    if (f(v).onsiteRequired) parts.push('Onsite');
                    if (f(v).remoteAllowed) parts.push('Remote OK');
                    if (f(v).travelAllowed) parts.push('Travel');
                    return parts.join(' · ') || undefined;
                }
            })
        ]
    });
}
